export default __webpack_public_path__ + "static/aqua-matrix-1f25eaa4174181a47200ab5f8a1ede5b.svg";